//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import headSearch from '~/components/common/headSearch.vue'
import allMenu from '~/components/common/allMenu.vue'
import languageList from '~/static/json/languageList.json'
import nozhlanguageList from '~/static/json/nozhlanguageList.json'
import loginBox from '~/components/login/loginBox.vue'
import googleLogin from '~/components/login/googleLogin.vue'
import { WEB_DOWNLOAD } from '@/mixins/sensor'
const _ = require('lodash')
export default {
  components: {
    'head-search': headSearch,
    'all-menu': allMenu,
    'login-box': loginBox,
    'google-login': googleLogin
  },
  mixins: [WEB_DOWNLOAD],
  data () {
    return {
      sidesObj: { langPop: true, menuPop: true, showSides: false }, // 是否展示侧边栏菜单导航（移动端）
      // 头部
      // langList: languageList, // 语言列表
      // navList: [ // 一级菜单导航列表
      //   { id: '1', name: '首页', ico: require('https://resources.interface003.com/web20/img/home/icon-menu1.svg'), url: `/${this.$store.state.LanguageCode}` },
      //   { id: '2', name: '交易商', ico: require('https://resources.interface003.com/web20/img/home/icon-menu2.svg'), url: `/${this.$store.state.LanguageCode}/search.html` },
      //   { id: '3', name: 'VPS', ico: require('https://resources.interface003.com/web20/img/home/icon-menu3.svg'), url: `https://cloud..com/${this.$store.state.LanguageCode}` },
      //   { id: '4', name: '集市', ico: require('https://resources.interface003.com/web20/img/home/icon-menu4.svg'), url: '/' },
      //   { id: '5', name: '曝光', ico: require('https://resources.interface003.com/web20/img/home/icon-menu5.svg'), url: '/' },
      //   { id: '6', name: '资讯', ico: require('https://resources.interface003.com/web20/img/home/icon-menu6.svg'), url: `/${this.$store.state.LanguageCode}/news.html` },
      //   { id: '7', name: '实勘', ico: require('https://resources.interface003.com/web20/img/home/icon-menu7.svg'), url: '/' },
      //   { id: '8', name: 'EA', ico: require('https://resources.interface003.com/web20/img/home/icon-menu8.svg'), url: '/' },
      //   { id: '9', name: 'Swift Codes', ico: require('https://resources.interface003.com/web20/img/home/icon-menu8.svg'), url: '/' },
      //   { id: '10', name: '财经日历', ico: require('https://resources.interface003.com/web20/img/home/icon-menu8.svg'), url: `/${this.$store.state.LanguageCode}/live/calendar.html` },
      //   { id: '11', name: '快讯', ico: require('https://resources.interface003.com/web20/img/home/icon-menu8.svg'), url: `/${this.$store.state.LanguageCode}/live/7x24.html` },
      //   { id: '12', name: '外汇工具', ico: require('https://resources.interface003.com/web20/img/home/icon-menu8.svg'), url: `/${this.$store.state.LanguageCode}/forex-tools.html` }
      // ],
      navList: [],
      visibleList: [], // 可见区域的菜单项
      invisibleList: [], // 不可见区域的菜单项
      // huntObj: { showMask: true, showBox: true, showInput: false }, // 是否展示搜索框，并打开遮罩
      huntObj: { showMask: false, showBox: false, showInput: true }, // 是否展示搜索框，并打开遮罩
      // loginShow: false, // 是否弹出登录框
      menuIndex: '',
      allmenuShow: false, // 下拉所有菜单是否显示
      userLink: [
        {
          // 用户中心跳转
          name: '会员中心',
          link: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${this.$store.state.LanguageCode}/usercenter/index.html`,
          icon: 'icon-zhongxin'
        },
        {
          name: '我的关注',
          link: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${this.$store.state.LanguageCode}/usercenter/trader.html`,
          icon: 'icon-guanzhu-1'
        },
        {
          name: '我的订单',
          link: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${this.$store.state.LanguageCode}/usercenter/vip.html`,
          icon: 'icon-dingdan'
        },
        {
          name: '我的发布',
          link: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${this.$store.state.LanguageCode}/usercenter/exposure.html`,
          icon: 'icon-fabu-1'
        },
        {
          name: '我的担保',
          link: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${this.$store.state.LanguageCode}/usercenter/epc.html`,
          icon: 'icon-danbao'
        },
        {
          name: '个人设置',
          link: `https://www.${this.$store.state.newhost}.${this.$store.state.suffix}/${this.$store.state.LanguageCode}/usercenter/setting.html`,
          icon: 'icon-set'
        },
        {
          name: '退出',
          link: 'javascript:void(0)',
          icon: 'icon-quit'
        }
      ],
      personalShow: false,
      autoshow: false // 表单是否自动聚焦
    }
  },
  computed: {
    ...mapState({
      pluginShow: 'pluginShow',
      mobile: 'mobile'
    }),
    // 本项目logo
    fxLogo () {
      const selectedLang = this.currLangCode()
      if (selectedLang == 'zh-cn')
        return 'https://resources.interface003.com/web20/img/home/logo-cn.svg'
      else if (selectedLang == 'ar')
        return 'https://resources.interface003.com/web20/img/home/logo-ar.svg'
      else if (['zh-tw', 'zh-hk', 'zh'].includes(selectedLang))
        return 'https://resources.interface003.com/web20/img/home/logo-tw.svg'
      else return 'https://resources.interface003.com/web20/img/home/logo-en.svg'
    },
    langList () {
      if (this.$store.state.riskcontrol['351001'] == '0') {
        return nozhlanguageList
      } else {
        return languageList
      }
    },
    // 当前选择的语言
    langName () {
      let langText = ''
      if (this.currLangCode() == 'zh-hk') langText = '繁體中文(香港)'
      else if (this.currLangCode() == 'zh-tw') langText = '繁體中文(臺灣)'
      else langText = (
        this.getMyLang({ LanguageCode: this.currLangCode() })?.Language ||
        'English'
      )
      return langText
    },
    educateshow () { // 教育显示得语言
      const l = 'zh-tw,en,ru,vi,th,id,es,fil'
      if (l.includes(this.$store.state.LanguageCode)) return true
      else return false
    },
    exposhow () { // WikiEXPO
      const l = 'zh-cn,zh,en,vi,th'
      if (l.includes(this.$store.state.LanguageCode)) return true
      else return false
    }
  },
  created () {
    // 处理可见区域的菜单项
    const arr = [...this.$store.state.menuData]
    if (!this.educateshow) arr.splice(arr.map(item => item.code).indexOf('menu_education_new'), 1)
    if (!this.exposhow) arr.splice(arr.map(item => item.code).indexOf('menu_wikiexpo'), 1)
    this.navList = [...arr]
    this.visibleList = _.cloneDeep(arr)
  },
  mounted () {
    // 通过计算菜单栏总长度，判断是否隐藏几项
    this.totalEle()
    window.onresize = () => {
      this.totalEle()
    }
    document.addEventListener('click', () => {
      this.personalShow = false
    })
  },
  methods: {
    abBrokerDomain (url) {
      // const keywords = ['privacy.html', '/news.html', '/newsdetail/', 'original.html', 'industry.html', 'brokernews.html', 'wikilist.html', 'evaluation.html', 'authority.html']
      const keywords = []
      return keywords.some(keyword => url.includes(keyword))
    },
    // 添加桌面快捷方式
    // async toDesktop () {
    toDesktop () {
      // const workbox = await window.$workbox
      // if (workbox) {
      // console.log('workbox', workbox)
      this.beforeinstallpromptListener()
      // Service worker is available
      // }
    },
    install () {
      // let e
      // const _that = this
      // null === (e = this.pwaTarget) || void 0 === e || e.prompt().then((function(e) {
      //     "accepted" === e.outcome && (_that.pwaTarget = null)
      // }
      // ))
    },
    beforeinstallpromptListener () {
      // const _that = this
      // if (window) {
      //   // window.addEventListener('beforeinstallprompt', (t) => {
      //   //   // t.preventDefault()
      //   //   // _that.pwaTarget = t
      //   //   t.prompt()
      //   //   // 判断用户是否安装
      //   //   event.userChoice.then((e) => {
      //   //     // install = true
      //   //     console.log('安转成功')
      //   //   })
      //   // }, { once: true })
      // }
    },
    personalFn () {
      // 点击头像下拉框是否显示
      this.personalShow = true
    },
    quit (val) {
      // 退出登录DJkdikKMG
      if (val != 'icon-quit') return
      this.dialogFn(false, 'menuPop')
      this.$cookies.remove('DJkdikKMG', { path: '/', domain: this.$store.state.cookieHost })
      this.$cookies.remove('ViLartidlakd', { path: '/', domain: this.$store.state.cookieHost })
      this.$cookies.remove('WsdsfgDGdagYms')
      this.$store.commit('setUser', {})
      this.$store.commit('setUsercookie', '')
    },
    menuSon (code) {
      // 子组件展开和缩起来
      if (this.menuIndex == code) {
        this.menuIndex = ''
        return
      }
      this.menuIndex = code
    },
    menuOver (item) {
      // 鼠标移入菜单事件
      this.menuIndex = item.code
    },
    menuLeave () {
      // 鼠标移出菜单事件
      this.menuIndex = ''
    },
    totalEle () {
      const [navDom, totalWidth] = [
        document.getElementsByClassName('item-nav'),
        this.$refs?.menuDom?.offsetWidth - 50
      ]
      const navLen = navDom?.length || 0 // 栏目数量
      let [tempWidth, navIdx] = [0, 0]
      for (navIdx = 0; navIdx < navLen; navIdx++) {
        tempWidth = _.add(_.add(navDom[navIdx]?.offsetWidth, 28), tempWidth) // 所有元素的宽度
        if (tempWidth > totalWidth) break
        this.visibleList = _.slice(this.navList, 0, _.add(navIdx, 1))
      }
      if (navIdx < navLen) this.invisibleList = _.slice(this.navList, navIdx)
    },
    login () {
      this.dialogFn(false, 'menuPop')
      // 点击登录
      const DJkdikKMG = this.$cookies.get('DJkdikKMG')
      const ViLartidlakd = this.$cookies.get('ViLartidlakd')
      const WsdsfgDGdagYms = this.$cookies.get('WsdsfgDGdagYms')
      const contentcookie = DJkdikKMG || ViLartidlakd || WsdsfgDGdagYms
      if (contentcookie) return null
      // this.$refs.loginBox.close = true
      this.$store.commit('loginClose', true)
      // this.loginShow = true
    },
    // 更换语言
    langFn (obj = {}, isDelay = false) {
      const langCode = obj?.LanguageCode || 'en'
      const { name = '', query = '' } = this.$route
      const params = this.$route.params || {}
      params.lang = langCode
      if (isDelay) this.dialogFn()
      const reloadTimer = setTimeout(
        () => {
          clearTimeout(reloadTimer)
          const routeData = this.$router?.resolve({ name, params, query })
          location.href = routeData?.href
        },
        isDelay ? 50 : 0
      )
    },
    // 侧边栏更换菜单
    menuFn (obj = {}) {
      this.dialogFn(false, 'menuPop')
    },
    // 打开/关闭侧边栏弹框
    dialogFn (isOpen = false, domName = 'langPop') {
      _.assign(
        this.sidesObj,
        isOpen ? { [domName]: false } : { showSides: false }
      ) // 打开弹框时，先移除隐藏样式；关闭弹框时，内容区先消失
      const openTimer = setTimeout(() => {
        clearTimeout(openTimer)
        _.assign(
          this.sidesObj,
          isOpen ? { showSides: true } : { [domName]: true }
        ) // 打开弹框一段时间后，内容区才出现；关闭弹框一段时间后，才添加隐藏样式
        if (domName == 'menuPop') {
          if (!this.sidesObj.menuPop) {
            document.body.style.overflow = 'hidden'
          } else {
            document.body.style.overflow = 'auto'
          }
        }
        if (domName == 'langPop') {
          if (!this.sidesObj.langPop) {
            document.body.style.overflow = 'hidden'
          } else {
            document.body.style.overflow = 'auto'
          }
        }
      }, 50)
    },
    // 展示搜索框，并打开遮罩
    expandInput (isOpen = false) {
      // _.assign(
      //   this.huntObj,
      //   isOpen ? { showMask: false, showBox: false } : { showInput: false }
      // )
      // const expandTimer = setTimeout(
      //   () => {
      //     clearTimeout(expandTimer)
      //     _.assign(
      //       this.huntObj,
      //       isOpen ? { showInput: true } : { showMask: true, showBox: true }
      //     )
      //   },
      //   isOpen ? 0 : 200
      // )
      // this.$nextTick(() => {
      //   // this.autoshow = true
      //   if (isOpen) {
      //     this.$refs.pcsearch.$refs.pcinput.focus()
      //     this.$refs.pcsearch.getfocus()
      //   }
      // })
    },
    downloadToSensor () {
      this.sensorTrackDownload(this.$route)
    }
  }
}
